export const bookClassification = {
  '건강/취미': {
    건강운동: {},
    걷기정보: {},
    공예: {},
    글씨쓰기: {},
  },
  고전: {
    고사성어: {},
    과학고전: {},
    군사고전: {},
    다시쓴고전: {},
  },
  과학: {
    기초과학: {},
    교양과학: {},
    '과학의 이해': {},
    법의학: {},
  },
  '대학교재/전문서적': {
    경상계열: {},
    공학계열: {},
    인문계열: {},
    전문사전: {},
  },
  만화: {
    캐릭터상품: {},
    교양만화: {},
    그래픽노블: {},
    인디만화: {},
  },
  '달력/기타': {
    가계부: {},
    다이어리: {},
    달력: {},
  },
  사회과학: {
    '비평/칼럼': {},
    사회문제: {},
    교육학: {},
    사회운동: {},
  },
  '소설/시/희곡': {
    한국소설: {},
    일본소설: {},
    영문소설: {},
    독일소설: {},
  },
  '수험서/자격증': {
    국가시술자격: {},
    민간자격: {},
    귀화시험: {},
    운전면허: {},
  },
  어린이: {
    '초등 한국사': {},
    학습만화: {},
    '아동 문학론': {},
  },
  에세이: {
    한국: {},
    외국: {},
    음식: {},
    명상: {},
  },
};

export const recordClassification = {
  가요: {
    뉴에이지: {},
    댄스뮤직: {},
    발라드: {},
    성인가요: {},
  },
  국악: {
    '국악-소리': {},
    '국악-연주': {},
    '국악-크로스오버': {},
    기타: {},
  },
  월드뮤직: {
    아메리카음악: {},
    아시아음악: {},
    아프리카음악: {},
    유럽음악: {},
  },
  재즈: {
    성악곡: {},
    연주곡: {},
    시리즈: {},
    퓨전: {},
  },
  '종교/명상/기타': {
    가톨릭: {},
    기독교: {},
    불교: {},
    기타: {},
  },
  클래식: {
    고음악: {},
    독주곡: {},
    실내악: {},
    협주곡: {},
  },
  팝: {
    뉴에이지: {},
    록: {},
    메탈: {},
    힙합: {},
  },
  해외구매: {
    DVD: {},
    클래식: {},
    팝: {},
    LP: {},
  },
  'J-POP': {
    뉴에이지: {},
    록: {},
    일렉트로닉: {},
  },
  LP: {
    클래식: {},
    팝: {},
    가요: {},
    재즈: {},
  },
  'O.S.T': {
    게임: {},
    뮤지컬: {},
    영화음악: {},
    기타: {},
  },
};
